const prefix = '[App] ';

const format = (args: unknown[]): string =>
  prefix + args.map((a) => (typeof a === 'string' ? a : JSON.stringify(a))).join(' ');

export const logger = {
  info: (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    console.info(format(args));
  },
  warn: (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    console.warn(format(args));
  },
  error: (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    console.error(format(args));
  },
  debug: (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    console.debug(format(args));
  },
};

export default logger;
